const allCountries = [
    {
        "name": "Algeria (+213)",
        "value": "213ALGERIA",
        "is_default": false,
        "iso2": "dz"
    },
    {
        "name": "Andorra (+376)",
        "value": "376ANDORRA",
        "is_default": false,
        "iso2": "ad"
    },
    {
        "name": "Angola (+244)",
        "value": "244ANGOLA",
        "is_default": false,
        "iso2": "ao"
    },
    {
        "name": "Anguilla (+1264)",
        "value": "1264ANGUILLA",
        "is_default": false,
        "iso2": "ai"
    },
    {
        "name": "Antigua & Barbuda (+1268)",
        "value": "1268ANTIGUABARBUDA",
        "is_default": false,
        "iso2": "ag"
    },
    {
        "name": "Argentina (+54)",
        "value": "54ARGENTINA",
        "is_default": false,
        "iso2": "ar"
    },
    {
        "name": "Armenia (+374)",
        "value": "374ARMENIA",
        "is_default": false,
        "iso2": "am"
    },
    {
        "name": "Aruba (+297)",
        "value": "297ARUBA",
        "is_default": false,
        "iso2": "aw"
    },
    {
        "name": "Australia (+61)",
        "value": "61AUSTRALIA",
        "is_default": false,
        "iso2": "au"
    },
    {
        "name": "Austria (+43)",
        "value": "43AUSTRIA",
        "is_default": false,
        "iso2": "at"
    },
    {
        "name": "Azerbaijan (+994)",
        "value": "994AZERBAIJAN",
        "is_default": false,
        "iso2": "az"
    },
    {
        "name": "Bahamas (+1242)",
        "value": "1242BAHAMAS",
        "is_default": false,
        "iso2": "bs"
    },
    {
        "name": "Bahrain (+973)",
        "value": "973BAHRAIN",
        "is_default": false,
        "iso2": "bh"
    },
    {
        "name": "Bangladesh (+880)",
        "value": "880BANGLADESH",
        "is_default": false,
        "iso2": "bd"
    },
    {
        "name": "Barbados (+1246)",
        "value": "1246BARBADOS",
        "is_default": false,
        "iso2": "bb"
    },
    {
        "name": "Belarus (+375)",
        "value": "375BELARUS",
        "is_default": false,
        "iso2": "by"
    },
    {
        "name": "Belgium (+32)",
        "value": "32BELGIUM",
        "is_default": false,
        "iso2": "be"
    },
    {
        "name": "Belize (+501)",
        "value": "501BELIZE",
        "is_default": false,
        "iso2": "bz"
    },
    {
        "name": "Benin (+229)",
        "value": "229BENIN",
        "is_default": false,
        "iso2": "bj"
    },
    {
        "name": "Bermuda (+1441)",
        "value": "1441BERMUDA",
        "is_default": false,
        "iso2": "bm"
    },
    {
        "name": "Bhutan (+975)",
        "value": "975BHUTAN",
        "is_default": false,
        "iso2": "bt"
    },
    {
        "name": "Bolivia (+591)",
        "value": "591BOLIVIA",
        "is_default": false,
        "iso2": "bo"
    },
    {
        "name": "Bosnia Herzegovina (+387)",
        "value": "387BOSNIAHERZEGOVINA",
        "is_default": false,
        "iso2": "ba"
    },
    {
        "name": "Botswana (+267)",
        "value": "267BOTSWANA",
        "is_default": false,
        "iso2": "bw"
    },
    {
        "name": "Brazil (+55)",
        "value": "55BRAZIL",
        "is_default": false,
        "iso2": "br"
    },
    {
        "name": "Brunei (+673)",
        "value": "673BRUNEI",
        "is_default": false,
        "iso2": "bn"
    },
    {
        "name": "Bulgaria (+359)",
        "value": "359BULGARIA",
        "is_default": false,
        "iso2": "bg"
    },
    {
        "name": "Burkina Faso (+226)",
        "value": "226BURKINAFASO",
        "is_default": false,
        "iso2": "bf"
    },
    {
        "name": "Burundi (+257)",
        "value": "257BURUNDI",
        "is_default": false,
        "iso2": "bi"
    },
    {
        "name": "Cambodia (+855)",
        "value": "855CAMBODIA",
        "is_default": false,
        "iso2": "kh"
    },
    {
        "name": "Cameroon (+237)",
        "value": "237CAMEROON",
        "is_default": false,
        "iso2": "cm"
    },
    {
        "name": "Canada (+1)",
        "value": "1CANADA",
        "is_default": false,
        "iso2": "ca"
    },
    {
        "name": "Cape Verde Islands (+238)",
        "value": "238CAPEVERDEISLANDS",
        "is_default": false,
        "iso2": "cv"
    },
    {
        "name": "Cayman Islands (+1345)",
        "value": "1345CAYMANISLANDS",
        "is_default": false,
        "iso2": "ky"
    },
    {
        "name": "Central African Republic (+236)",
        "value": "236CENTRALAFRICANREPUBLIC",
        "is_default": false,
        "iso2": "cf"
    },
    {
        "name": "Chile (+56)",
        "value": "56CHILE",
        "is_default": false,
        "iso2": "cl"
    },
    {
        "name": "China (+86)",
        "value": "86CHINA",
        "is_default": false,
        "iso2": "cn"
    },
    {
        "name": "Colombia (+57)",
        "value": "57COLOMBIA",
        "is_default": false,
        "iso2": "co"
    },
    {
        "name": "Comoros (+269)",
        "value": "269COMOROS",
        "is_default": false,
        "iso2": "km"
    },
    {
        "name": "Congo (+242)",
        "value": "242CONGO",
        "is_default": false,
        "iso2": "cd"
    },
    {
        "name": "Cook Islands (+682)",
        "value": "682COOKISLANDS",
        "is_default": false,
        "iso2": "ck"
    },
    {
        "name": "Costa Rica (+506)",
        "value": "506COSTARICA",
        "is_default": false,
        "iso2": "cr"
    },
    {
        "name": "Croatia (+385)",
        "value": "385CROATIA",
        "is_default": false,
        "iso2": "hr"
    },
    {
        "name": "Cuba (+53)",
        "value": "53CUBA",
        "is_default": false,
        "iso2": "cu"
    },
    {
        "name": "Cyprus North (+90392)",
        "value": "90392CYPRUSNORTH",
        "is_default": false,
        "iso2": "cy"
    },
    {
        "name": "Cyprus South (+357)",
        "value": "357CYPRUSSOUTH",
        "is_default": false,
        "iso2": "cy"
    },
    {
        "name": "Czech Republic (+420)",
        "value": "420CZECHREPUBLIC",
        "is_default": false,
        "iso2": "cz"
    },
    {
        "name": "Denmark (+45)",
        "value": "45DENMARK",
        "is_default": false,
        "iso2": "dk"
    },
    {
        "name": "Djibouti (+253)",
        "value": "253DJIBOUTI",
        "is_default": false,
        "iso2": "dj"
    },
    {
        "name": "Dominica (+1809)",
        "value": "1809DOMINICA",
        "is_default": false,
        "iso2": "dm"
    },
    {
        "name": "Dominican Republic (+1809)",
        "value": "1809DOMINICANREPUBLIC",
        "is_default": false,
        "iso2": "dm"
    },
    {
        "name": "Dominican Republic (+1829)",
        "value": "1829DOMINICANREPUBLIC",
        "is_default": false,
        "iso2": "dm"
    },
    {
        "name": "Dominican Republic (+1849)",
        "value": "1849DOMINICANREPUBLIC",
        "is_default": false,
        "iso2": "dm"
    },    
    {
        "name": "Ecuador (+593)",
        "value": "593ECUADOR",
        "is_default": false,
        "iso2": "ec"
    },
    {
        "name": "Egypt (+20)",
        "value": "20EGYPT",
        "is_default": false,
        "iso2": "eg"
    },
    {
        "name": "El Salvador (+503)",
        "value": "503ELSALVADOR",
        "is_default": false,
        "iso2": "sv"
    },
    {
        "name": "Equatorial Guinea (+240)",
        "value": "240EQUATORIALGUINEA",
        "is_default": false,
        "iso2": "gn"
    },
    {
        "name": "Eritrea (+291)",
        "value": "291ERITREA",
        "is_default": false,
        "iso2": "er"
    },
    {
        "name": "Estonia (+372)",
        "value": "372ESTONIA",
        "is_default": false,
        "iso2": "ee"
    },
    {
        "name": "Ethiopia (+251)",
        "value": "251ETHIOPIA",
        "is_default": false,
        "iso2": "et"
    },
    {
        "name": "Falkland Islands (+500)",
        "value": "500FALKLANDISLANDS",
        "is_default": false,
        "iso2": "fk"
    },
    {
        "name": "Faroe Islands (+298)",
        "value": "298FAROEISLANDS",
        "is_default": false,
        "iso2": "fo"
    },
    {
        "name": "Fiji (+679)",
        "value": "679FIJI",
        "is_default": false,
        "iso2": "fj"
    },
    {
        "name": "Finland (+358)",
        "value": "358FINLAND",
        "is_default": false,
        "iso2": "fi"
    },
    {
        "name": "France (+33)",
        "value": "33FRANCE",
        "is_default": false,
        "iso2": "fr"
    },
    {
        "name": "French Guiana (+594)",
        "value": "594FRENCHGUIANA",
        "is_default": false,
        "iso2": "gf"
    },
    {
        "name": "French Polynesia (+689)",
        "value": "689FRENCHPOLYNESIA",
        "is_default": false,
        "iso2": "pf"
    },
    {
        "name": "Gabon (+241)",
        "value": "241GABON",
        "is_default": false,
        "iso2": "ga"
    },
    {
        "name": "Gambia (+220)",
        "value": "220GAMBIA",
        "is_default": false,
        "iso2": "gm"
    },
    {
        "name": "Georgia (+7880)",
        "value": "7880GEORGIA",
        "is_default": false,
        "iso2": "ge"
    },
    {
        "name": "Germany (+49)",
        "value": "49GERMANY",
        "is_default": false,
        "iso2": "de"
    },
    {
        "name": "Ghana (+233)",
        "value": "233GHANA",
        "is_default": false,
        "iso2": "gh"
    },
    {
        "name": "Gibraltar (+350)",
        "value": "350GIBRALTAR",
        "is_default": false,
        "iso2": "gi"
    },
    {
        "name": "Greece (+30)",
        "value": "30GREECE",
        "is_default": false,
        "iso2": "gr"
    },
    {
        "name": "Greenland (+299)",
        "value": "299GREENLAND",
        "is_default": false,
        "iso2": "gl"
    },
    {
        "name": "Grenada (+1473)",
        "value": "1473GRENADA",
        "is_default": false,
        "iso2": "gd"
    },
    {
        "name": "Guadeloupe (+590)",
        "value": "590GUADELOUPE",
        "is_default": false,
        "iso2": "gp"
    },
    {
        "name": "Guam (+671)",
        "value": "671GUAM",
        "is_default": false,
        "iso2": "gu"
    },
    {
        "name": "Guatemala (+502)",
        "value": "502GUATEMALA",
        "is_default": false,
        "iso2": "gt"
    },
    {
        "name": "Guinea (+224)",
        "value": "224GUINEA",
        "is_default": false,
        "iso2": "gn"
    },
    {
        "name": "Guinea - Bissau (+245)",
        "value": "245GUINEABISSAU",
        "is_default": false,
        "iso2": "gn"
    },
    {
        "name": "Guyana (+592)",
        "value": "592GUYANA",
        "is_default": false,
        "iso2": "gy"
    },
    {
        "name": "Haiti (+509)",
        "value": "509HAITI",
        "is_default": false,
        "iso2": "ht"
    },
    {
        "name": "Honduras (+504)",
        "value": "504HONDURAS",
        "is_default": false,
        "iso2": "hn"
    },
    {
        "name": "Hong Kong (+852)",
        "value": "852HONGKONG",
        "is_default": false,
        "iso2": "hk"
    },
    {
        "name": "Hungary (+36)",
        "value": "36HUNGARY",
        "is_default": false,
        "iso2": "hu"
    },
    {
        "name": "Iceland (+354)",
        "value": "354ICELAND",
        "is_default": false,
        "iso2": "is"
    },
    {
        "name": "India (+91)",
        "value": "91INDIA",
        "is_default": false,
        "iso2": "in"
    },
    {
        "name": "Indonesia (+62)",
        "value": "62INDONESIA",
        "is_default": false,
        "iso2": "id"
    },
    {
        "name": "Iran (+98)",
        "value": "98IRAN",
        "is_default": false,
        "iso2": "ir"
    },
    {
        "name": "Iraq (+964)",
        "value": "964IRAQ",
        "is_default": false,
        "iso2": "iq"
    },
    {
        "name": "Ireland (+353)",
        "value": "353IRELAND",
        "is_default": false,
        "iso2": "ie"
    },
    {
        "name": "Israel (+972)",
        "value": "972ISRAEL",
        "is_default": false,
        "iso2": "il"
    },
    {
        "name": "Italy (+39)",
        "value": "39ITALY",
        "is_default": false,
        "iso2": "it"
    },
    {
        "name": "Jamaica (+1876)",
        "value": "1876JAMAICA",
        "is_default": false,
        "iso2": "jm"
    },
    {
        "name": "Japan (+81)",
        "value": "81JAPAN",
        "is_default": false,
        "iso2": "jp"
    },
    {
        "name": "Jordan (+962)",
        "value": "962JORDAN",
        "is_default": false,
        "iso2": "jo"
    },
    {
        "name": "Kazakhstan (+7)",
        "value": "7KAZAKHSTAN",
        "is_default": false,
        "iso2": "kz"
    },
    {
        "name": "Kenya (+254)",
        "value": "254KENYA",
        "is_default": false,
        "iso2": "ke"
    },
    {
        "name": "Kiribati (+686)",
        "value": "686KIRIBATI",
        "is_default": false,
        "iso2": "ki"
    },
    {
        "name": "Korea North (+850)",
        "value": "850KOREANORTH",
        "is_default": false,
        "iso2": "kp"
    },
    {
        "name": "Korea South (+82)",
        "value": "82KOREASOUTH",
        "is_default": false,
        "iso2": "kr"
    },
    {
        "name": "Kuwait (+965)",
        "value": "965KUWAIT",
        "is_default": false,
        "iso2": "kw"
    },
    {
        "name": "Kyrgyzstan (+996)",
        "value": "996KYRGYZSTAN",
        "is_default": false,
        "iso2": "kg"
    },
    {
        "name": "Laos (+856)",
        "value": "856LAOS",
        "is_default": false,
        "iso2": "la"
    },
    {
        "name": "Latvia (+371)",
        "value": "371LATVIA",
        "is_default": false,
        "iso2": "lv"
    },
    {
        "name": "Lebanon (+961)",
        "value": "961LEBANON",
        "is_default": false,
        "iso2": "lb"
    },
    {
        "name": "Lesotho (+266)",
        "value": "266LESOTHO",
        "is_default": false,
        "iso2": "ls"
    },
    {
        "name": "Liberia (+231)",
        "value": "231LIBERIA",
        "is_default": false,
        "iso2": "lr"
    },
    {
        "name": "Libya (+218)",
        "value": "218LIBYA",
        "is_default": false,
        "iso2": "ly"
    },
    {
        "name": "Liechtenstein (+417)",
        "value": "417LIECHTENSTEIN",
        "is_default": false,
        "iso2": "li"
    },
    {
        "name": "Lithuania (+370)",
        "value": "370LITHUANIA",
        "is_default": false,
        "iso2": "lt"
    },
    {
        "name": "Luxembourg (+352)",
        "value": "352LUXEMBOURG",
        "is_default": false,
        "iso2": "lu"
    },
    {
        "name": "Macao (+853)",
        "value": "853MACAO",
        "is_default": false,
        "iso2": "mo"
    },
    {
        "name": "Macedonia (+389)",
        "value": "389MACEDONIA",
        "is_default": false,
        "iso2": "mk"
    },
    {
        "name": "Madagascar (+261)",
        "value": "261MADAGASCAR",
        "is_default": false,
        "iso2": "mg"
    },
    {
        "name": "Malawi (+265)",
        "value": "265MALAWI",
        "is_default": false,
        "iso2": "mw"
    },
    {
        "name": "Malaysia (+60)",
        "value": "60MALAYSIA",
        "is_default": false,
        "iso2": "my"
    },
    {
        "name": "Maldives (+960)",
        "value": "960MALDIVES",
        "is_default": false,
        "iso2": "mv"
    },
    {
        "name": "Mali (+223)",
        "value": "223MALI",
        "is_default": false,
        "iso2": "ml"
    },
    {
        "name": "Malta (+356)",
        "value": "356MALTA",
        "is_default": false,
        "iso2": "mt"
    },
    {
        "name": "Marshall Islands (+692)",
        "value": "692MARSHALLISLANDS",
        "is_default": false,
        "iso2": "mh"
    },
    {
        "name": "Martinique (+596)",
        "value": "596MARTINIQUE",
        "is_default": false,
        "iso2": "mq"
    },
    {
        "name": "Mauritania (+222)",
        "value": "222MAURITANIA",
        "is_default": false,
        "iso2": "mr"
    },
    {
        "name": "Mayotte (+269)",
        "value": "269MAYOTTE",
        "is_default": false,
        "iso2": "yt"
    },
    {
        "name": "Mexico (+52)",
        "value": "52MEXICO",
        "is_default": false,
        "iso2": "mx"
    },
    {
        "name": "Micronesia (+691)",
        "value": "691MICRONESIA",
        "is_default": false,
        "iso2": "fm"
    },
    {
        "name": "Moldova (+373)",
        "value": "373MOLDOVA",
        "is_default": false,
        "iso2": "md"
    },
    {
        "name": "Monaco (+377)",
        "value": "377MONACO",
        "is_default": false,
        "iso2": "mc"
    },
    {
        "name": "Mongolia (+976)",
        "value": "976MONGOLIA",
        "is_default": false,
        "iso2": "mn"
    },
    {
        "name": "Montserrat (+1664)",
        "value": "1664MONTSERRAT",
        "is_default": false,
        "iso2": "ms"
    },
    {
        "name": "Morocco (+212)",
        "value": "212MOROCCO",
        "is_default": false,
        "iso2": "ma"
    },
    {
        "name": "Mozambique (+258)",
        "value": "258MOZAMBIQUE",
        "is_default": false,
        "iso2": "mz"
    },
    {
        "name": "Myanmar (+95)",
        "value": "95MYANMAR",
        "is_default": false,
        "iso2": "mm"
    },
    {
        "name": "Namibia (+264)",
        "value": "264NAMIBIA",
        "is_default": false,
        "iso2": "na"
    },
    {
        "name": "Nauru (+674)",
        "value": "674NAURU",
        "is_default": false,
        "iso2": "nr"
    },
    {
        "name": "Nepal (+977)",
        "value": "977NEPAL",
        "is_default": false,
        "iso2": "np"
    },
    {
        "name": "Netherlands (+31)",
        "value": "31NETHERLANDS",
        "is_default": false,
        "iso2": "nl"
    },
    {
        "name": "New Caledonia (+687)",
        "value": "687NEWCALEDONIA",
        "is_default": false,
        "iso2": "nc"
    },
    {
        "name": "New Zealand (+64)",
        "value": "64NEWZEALAND",
        "is_default": false,
        "iso2": "nz"
    },
    {
        "name": "Nicaragua (+505)",
        "value": "505NICARAGUA",
        "is_default": false,
        "iso2": "ni"
    },
    {
        "name": "Niger (+227)",
        "value": "227NIGER",
        "is_default": false,
        "iso2": "ne"
    },
    {
        "name": "Nigeria (+234)",
        "value": "234NIGERIA",
        "is_default": false,
        "iso2": "ne"
    },
    {
        "name": "Niue (+683)",
        "value": "683NIUE",
        "is_default": false,
        "iso2": "nu"
    },
    {
        "name": "Norfolk Islands (+672)",
        "value": "672NORFOLKISLANDS",
        "is_default": false,
        "iso2": "nf"
    },
    {
        "name": "Northern Marianas (+670)",
        "value": "670NORTHERNMARIANAS",
        "is_default": false,
        "iso2": "mp"
    },
    {
        "name": "Norway (+47)",
        "value": "47NORWAY",
        "is_default": false,
        "iso2": "no"
    },
    {
        "name": "Oman (+968)",
        "value": "968OMAN",
        "is_default": false,
        "iso2": "om"
    },
    {
        "name": "Palau (+680)",
        "value": "680PALAU",
        "is_default": false,
        "iso2": "pw"
    },
    {
        "name": "Panama (+507)",
        "value": "507PANAMA",
        "is_default": false,
        "iso2": "pa"
    },
    {
        "name": "Papua New Guinea (+675)",
        "value": "675PAPUANEWGUINEA",
        "is_default": false,
        "iso2": "gn"
    },
    {
        "name": "Paraguay (+595)",
        "value": "595PARAGUAY",
        "is_default": false,
        "iso2": "py"
    },
    {
        "name": "Peru (+51)",
        "value": "51PERU",
        "is_default": false,
        "iso2": "pe"
    },
    {
        "name": "Philippines (+63)",
        "value": "63PHILIPPINES",
        "is_default": false,
        "iso2": "ph"
    },
    {
        "name": "Poland (+48)",
        "value": "48POLAND",
        "is_default": false,
        "iso2": "pl"
    },
    {
        "name": "Portugal (+351)",
        "value": "351PORTUGAL",
        "is_default": false,
        "iso2": "pt"
    },
    {
        "name": "Puerto Rico (+1787)",
        "value": "1787PUERTORICO",
        "is_default": false,
        "iso2": "pr"
    },
    {
        "name": "Qatar (+974)",
        "value": "974QATAR",
        "is_default": false,
        "iso2": "qa"
    },
    {
        "name": "Reunion (+262)",
        "value": "262REUNION",
        "is_default": false,
        "iso2": "re"
    },
    {
        "name": "Romania (+40)",
        "value": "40ROMANIA",
        "is_default": false,
        "iso2": "ro"
    },
    {
        "name": "Russia (+7)",
        "value": "7RUSSIA",
        "is_default": false,
        "iso2": "ru"
    },
    {
        "name": "Rwanda (+250)",
        "value": "250RWANDA",
        "is_default": false,
        "iso2": "rw"
    },
    {
        "name": "San Marino (+378)",
        "value": "378SANMARINO",
        "is_default": false,
        "iso2": "sm"
    },
    {
        "name": "Sao Tome & Principe (+239)",
        "value": "239SAOTOMEPRINCIPE",
        "is_default": false,
        "iso2": "st"
    },
    {
        "name": "Saudi Arabia (+966)",
        "value": "966SAUDIARABIA",
        "is_default": false,
        "iso2": "sa"
    },
    {
        "name": "Senegal (+221)",
        "value": "221SENEGAL",
        "is_default": false,
        "iso2": "sn"
    },
    {
        "name": "Serbia (+381)",
        "value": "381SERBIA",
        "is_default": false,
        "iso2": "rs"
    },
    {
        "name": "Seychelles (+248)",
        "value": "248SEYCHELLES",
        "is_default": false,
        "iso2": "sc"
    },
    {
        "name": "Sierra Leone (+232)",
        "value": "232SIERRALEONE",
        "is_default": false,
        "iso2": "sl"
    },
    {
        "name": "Singapore (+65)",
        "value": "65SINGAPORE",
        "is_default": false,
        "iso2": "sg"
    },
    {
        "name": "Slovak Republic (+421)",
        "value": "421SLOVAKREPUBLIC",
        "is_default": false,
        "iso2": "sk"
    },
    {
        "name": "Slovenia (+386)",
        "value": "386SLOVENIA",
        "is_default": false,
        "iso2": "si"
    },
    {
        "name": "Solomon Islands (+677)",
        "value": "677SOLOMONISLANDS",
        "is_default": false,
        "iso2": "sb"
    },
    {
        "name": "Somalia (+252)",
        "value": "252SOMALIA",
        "is_default": false,
        "iso2": "ml"
    },
    {
        "name": "South Africa (+27)",
        "value": "27SOUTHAFRICA",
        "is_default": false,
        "iso2": "za"
    },
    {
        "name": "Spain (+34)",
        "value": "34SPAIN",
        "is_default": false,
        "iso2": "es"
    },
    {
        "name": "Sri Lanka (+94)",
        "value": "94SRILANKA",
        "is_default": false,
        "iso2": "lk"
    },
    {
        "name": "St. Helena (+290)",
        "value": "290STHELENA",
        "is_default": false,
        "iso2": "sh"
    },
    {
        "name": "St. Kitts (+1869)",
        "value": "1869STKITTS",
        "is_default": false,
        "iso2": "kn"
    },
    {
        "name": "St. Lucia (+1758)",
        "value": "1758STLUCIA",
        "is_default": false,
        "iso2": "lc"
    },
    {
        "name": "Sudan (+249)",
        "value": "249SUDAN",
        "is_default": false,
        "iso2": "sd"
    },
    {
        "name": "Suriname (+597)",
        "value": "597SURINAME",
        "is_default": false,
        "iso2": "sr"
    },
    {
        "name": "Swaziland (+268)",
        "value": "268SWAZILAND",
        "is_default": false,
        "iso2": "sz"
    },
    {
        "name": "Sweden (+46)",
        "value": "46SWEDEN",
        "is_default": false,
        "iso2": "se"
    },
    {
        "name": "Switzerland (+41)",
        "value": "41SWITZERLAND",
        "is_default": false,
        "iso2": "ch"
    },
    {
        "name": "Syria (+963)",
        "value": "963SYRIA",
        "is_default": false,
        "iso2": "sy"
    },
    {
        "name": "Taiwan (+886)",
        "value": "886TAIWAN",
        "is_default": false,
        "iso2": "tw"
    },
    {
        "name": "Tajikstan (+7)",
        "value": "7TAJIKSTAN",
        "is_default": false,
        "iso2": "tj"
    },
    {
        "name": "Thailand (+66)",
        "value": "66THAILAND",
        "is_default": false,
        "iso2": "th"
    },
    {
        "name": "Togo (+228)",
        "value": "228TOGO",
        "is_default": false,
        "iso2": "tg"
    },
    {
        "name": "Tonga (+676)",
        "value": "676TONGA",
        "is_default": false,
        "iso2": "to"
    },
    {
        "name": "Trinidad & Tobago (+1868)",
        "value": "1868TRINIDADTOBAGO",
        "is_default": false,
        "iso2": "tt"
    },
    {
        "name": "Tunisia (+216)",
        "value": "216TUNISIA",
        "is_default": false,
        "iso2": "tn"
    },
    {
        "name": "Turkey (+90)",
        "value": "90TURKEY",
        "is_default": false,
        "iso2": "tr"
    },
    {
        "name": "Turkmenistan (+7)",
        "value": "7TURKMENISTAN",
        "is_default": false,
        "iso2": "tm"
    },
    {
        "name": "Turkmenistan (+993)",
        "value": "993TURKMENISTAN",
        "is_default": false,
        "iso2": "tm"
    },
    {
        "name": "Turks & Caicos Islands (+1649)",
        "value": "1649TURKSCAICOSISLANDS",
        "is_default": false,
        "iso2": "tc"
    },
    {
        "name": "Tuvalu (+688)",
        "value": "688TUVALU",
        "is_default": false,
        "iso2": "tv"
    },
    {
        "name": "Uganda (+256)",
        "value": "256UGANDA",
        "is_default": false,
        "iso2": "ug"
    },
    {
        "name": "Ukraine (+380)",
        "value": "380UKRAINE",
        "is_default": false,
        "iso2": "ua"
    },
    {
        "name": "UK (+44)",
        "value": "44UK",
        "is_default": false,
        "iso2": "ua"
    },
    {
        "name": "United Arab Emirates (+971)",
        "value": "971UNITEDARABEMIRATES",
        "is_default": false,
        "iso2": "ae"
    },
    {
        "name": "Uruguay (+598)",
        "value": "598URUGUAY",
        "is_default": false,
        "iso2": "uy"
    },
    {
        "name": "USA (+1)",
        "value": "1USA",
        "is_default": false,
        "iso2": "us"
    },
    {
        "name": "Uzbekistan (+7)",
        "value": "7UZBEKISTAN",
        "is_default": false,
        "iso2": "uz"
    },
    {
        "name": "Vanuatu (+678)",
        "value": "678VANUATU",
        "is_default": false,
        "iso2": "vu"
    },
    {
        "name": "Vatican City (+379)",
        "value": "379VATICANCITY",
        "is_default": false,
        "iso2": "va"
    },
    {
        "name": "Venezuela (+58)",
        "value": "58VENEZUELA",
        "is_default": false,
        "iso2": "ve"
    },
    {
        "name": "Vietnam (+84)",
        "value": "84VIETNAM",
        "is_default": false,
        "iso2": "vn"
    },
    {
        "name": "Virgin Islands - British (+84)",
        "value": "84VIRGINISLANDSBRITISH",
        "is_default": false,
        "iso2": "vg"
    },
    {
        "name": "Virgin Islands - US (+84)",
        "value": "84VIRGINISLANDSUS",
        "is_default": false,
        "iso2": "vi"
    },
    {
        "name": "Wallis & Futuna (+681)",
        "value": "681WALLISFUTUNA",
        "is_default": false,
        "iso2": "wf"
    },
    {
        "name": "Yemen (North) (+969)",
        "value": "969YEMENNORTH",
        "is_default": false,
        "iso2": "ye"
    },
    {
        "name": "Yemen (South) (+967)",
        "value": "967YEMENSOUTH",
        "is_default": false,
        "iso2": "ye"
    },
    {
        "name": "Zambia (+260)",
        "value": "260ZAMBIA",
        "is_default": false,
        "iso2": "zm"
    },
    {
        "name": "Zimbabwe (+263)",
        "value": "263ZIMBABWE",
        "is_default": false,
        "iso2": "zw"
    }
];

export default allCountries.map((c) => {
    return {
        name: c.name,
        iso2: c.iso2.toUpperCase(),
        dialCode: /\((.*?)\)/.exec(c.name)[1],
        value: c.value
    }
});